import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Box, CircularProgress, Fab, Tooltip, Typography } from '@material-ui/core'
import { Description, HighlightOffOutlined, PictureAsPdf } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core/styles/createMuiTheme'

const Centered = styled.div`
  text-align: center;
`

const useStyles = makeStyles((theme: Theme) => ({
  image: {
    display: 'block',
    marginRight: 'auto',
    marginLeft: 'auto',
    height: 100,
    width: 'initial',
    maxWidth: '100%',
    color: theme.palette.text.primary,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxSizing: 'border-box',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px',
    borderRadius: theme.shape.borderRadius,
    zIndex: 5,
    opacity: 1,
  },
  filename: {
    wordWrap: 'break-word',
  },
}))

interface RenderProps {
  file: File
}

export const Render = (props: RenderProps) => {
  const { file } = props
  const classes = useStyles()
  const [data, setData] = useState<string | ArrayBuffer | null>(null)

  const types = file.type.split('/')
  const base = types[0]
  const specific = types[1]

  useEffect(() => {
    if (base === 'image') {
      const reader = new FileReader()
      reader.onload = () => {
        setData(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }, [file, base])

  if (base === 'image') {
    return <img className={classes.image} src={data as string} alt={file.name} />
  } else if (specific === 'pdf') {
    return <PictureAsPdf className={classes.image} />
  } else if (base === 'loading') {
    return <CircularProgress className={classes.image} />
  } else {
    return <Description className={classes.image} />
  }
}

interface FilePreviewProps {
  file: File
  onDelete?: () => void
}

export const FilePreview = (props: FilePreviewProps) => {
  const { file, onDelete } = props
  const classes = useStyles()
  const [hover, setHover] = useState(false)

  return (
    <Box
      position="relative"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Centered>
        <Tooltip title={file.name} arrow>
          <div>
            <Render file={file} />
            <Typography className={classes.filename} variant="body1" component="p" noWrap>
              {file.name}
            </Typography>
          </div>
        </Tooltip>
      </Centered>
      {hover && !!onDelete && (
        <Box position="absolute" zIndex="modal" top="5%" right="10%">
          <Fab size="small" onClick={() => onDelete()}>
            <HighlightOffOutlined />
          </Fab>
        </Box>
      )}
    </Box>
  )
}
